











































































































import Vue from "vue";
import MyChart from "../MyChart"

export default Vue.extend({
  components: {
    MyChart
  },
  data() {
    return {
      isOverstaffed: false,
      lossInEuro: 0,
      datacollection: null as any,
      weekday: "1",
      benötigteProduktivität: 0,
      stundenumsatzProGast: 0,
      gästeproduktivität: 0,
    };
  },
    created: function() {

        const mitarbeiterAnzahlDiffPerMeoRow = [] as number[];

        // validate meo
        this.benötigteProduktivität = this.$store.state.personalkostensatz / (this.$store.state.personalkostenquote / 100);
        this.stundenumsatzProGast = this.$store.state.umsatzProGast / this.$store.state.gastVerweildauer;
        this.gästeproduktivität = this.benötigteProduktivität / this.stundenumsatzProGast;
        const maxHourlySales = this.$store.getters.getMaxSales() * 1.25;
        const numberOfRows = maxHourlySales / this.stundenumsatzProGast / this.gästeproduktivität;
        this.isOverstaffed = false;
        for (let i = 0; i <= numberOfRows; i++) {
            const anzahlGäste = (i+1) * this.gästeproduktivität;
            let sum = 0;
            for (const group of this.$store.state.groups ?? []) {
                const n = this.$store.getters.getMeoValueForGroupAndRowId(group, i);
                sum += parseInt((n !== "" ? n : 0));
            }
            const diff = sum - (i + 1);
            if (diff > 0) {
                this.isOverstaffed = true;
            }
            mitarbeiterAnzahlDiffPerMeoRow[i] = Math.max(diff,0);
        }

        // calculate loss
        if(this.isOverstaffed) {
            this.lossInEuro=0;
            const salesByWeekdayAndHour = this.$store.state.salesByWeekdayAndHour as Map<string,Map<string,number>>;
            salesByWeekdayAndHour.forEach((salesPerHour,weekday)=>{
                salesPerHour.forEach((salesInEuro,hour)=>{
                    // determine meo row
                    const numberOfGuests = Math.round(salesInEuro / this.stundenumsatzProGast);
                    const meoRowIndex = Math.max(Math.round(numberOfGuests / this.gästeproduktivität) - 1, 0);
                    // sum up dif
                    const diff = mitarbeiterAnzahlDiffPerMeoRow[meoRowIndex];
                    if (diff > 0) {
                        this.lossInEuro += diff * this.$store.state.personalkostensatz;
                    }
                });
            });
        }

        // create diagram
        this.createDiagram(this.weekday);

    },
  computed: {
  },
  methods: {
    onChangeWeekday: function(event:any) {
      this.weekday = event.target.value;
      this.createDiagram(this.weekday);
    },
    createDiagram: function(weekday:string) {
      const salesPerHour = this.$store.getters.getSalesForWeekday(weekday) as Map<string,number>;
      if (!salesPerHour) {
        this.$notification.open({
          message: "Umsätze nicht angegeben",
          description: "Für den gewünschten Wochentag wurden keine Umsätze angegeben.",
          placement: "bottomRight",
        });
      }
      const labels = [] as string[];
      const benötigteProduktivitätYValues = [] as number[];
      const salesYValues = [] as number[];
      salesPerHour.forEach((salesInEuro,hour)=>{
        // build x-axis
        labels.push(hour + " Uhr");
        // build chart
        benötigteProduktivitätYValues.push(this.benötigteProduktivität);
        let numberOfEmployees = 0;
        for (const group of this.$store.state.groups ?? []) {
          const numberOfGuests = Math.round(salesInEuro / this.stundenumsatzProGast);
          const meoRowIndex = Math.max(Math.round(numberOfGuests / this.gästeproduktivität) - 1, 0);
          const n = this.$store.getters.getMeoValueForGroupAndRowId(group, meoRowIndex);
          if (n && !isNaN(n)) {
            numberOfEmployees += n;
          }
        }
        numberOfEmployees = Math.max(1,numberOfEmployees);
        salesYValues.push(salesInEuro/numberOfEmployees);
      });

      this.datacollection = {
        labels,
        datasets: [
          {
            label: 'Benötigte Produktivität',
            borderColor: '#36b2c2',
            strokeColor: '#36b2c2',
            pointRadius: 0,
            fill: false,
            data: benötigteProduktivitätYValues,
            type: "line"
          }, {
            label: 'Erwarteter Umsatz',
            borderColor: '#1890ff',
            borderWidth: 1,
            backgroundColor: 'rgba(24,144,255,0.2)',
            hoverBackgroundColor: 'rgba(24,144,255,0.3)',
            fill: true,
            data: salesYValues,
            type: "bar"
          }
        ]
      }
    },
    onNavToNesto:function() {
      location.href="https://nesto-software.de";
    }
  }
});
